import React, {useState} from 'react';
import {NumberFormatter} from 'react-number-formatter';
import {MDBCard, MDBCardBody, MDBCheckbox, MDBInput, MDBValidation, MDBValidationItem} from 'mdb-react-ui-kit';
import {Button} from "@mui/material";
import Box from "@mui/material/Box";

const Contacts = (props) => {
    var contacts= JSON.parse( localStorage.getItem('contacts'))
    const [number, setNumber] = useState(contacts.phone);

    const [formValue, setFormValue] = useState(contacts);


    const onChange = (e: any) => {
       // console.log(e)
        setFormValue({ ...formValue, [e.target.name]: e.target.value });

    };
    const onChtel= (e:any)=> {
        setFormValue({ ...formValue, ["phone"]: e});

    }
    const onChangecheck = (e: any) => {
         setFormValue({ ...formValue, [e.target.name]: e.target.checked });
    };
    localStorage.setItem('contacts',JSON.stringify(formValue));
    return (
        <>
        <MDBCard>
            <MDBCardBody>

            <MDBValidation className='g-3' isValidated>
                <MDBValidationItem  feedback='Пожалуйста, укажите фамилию и имя'  invalid className='col-md-4  mb-4'>
                    <MDBInput
                        value={formValue.fname}
                        name='fname'
                        onChange={onChange}
                        id='validationCustom01'
                        required
                        label='Фамилия Имя Отчество'
                    />
                </MDBValidationItem>


                <MDBValidationItem  feedback='Пожалуйста, укажите Email'  invalid className='col-md-4 mb-4'>
                    <MDBInput
                        value={formValue.email}
                        name='email'
                        onChange={onChange}
                        id='validationCustom03'
                        required
                        label='E-mail'
                    />
                </MDBValidationItem>
                <NumberFormatter
                    defaultCountry="RUS"
                    onlyCountries={["RUS"]}
                    value={formValue.phone}
                    name='phone'
                    fullIsoCode={true}
                    searchOption={false}
                    getValue={onChtel}
                />
                <MDBCheckbox
                    onChange={onChangecheck}
                    name='tlg'
                    checked={formValue.tlg}
                    // value={formValue.tlg}
                    label='Продублировать информацию о заказе в Telegram'
                    id='invalidCheck'  />
            </MDBValidation>

            </MDBCardBody>
        </MDBCard>
    <Box sx={{ mb: 2 }}>
        <div>

            <Button
                variant="contained"
                onClick={props.callNext}
                sx={{ mt: 1, mr: 1 }}
            >
                Далее
            </Button>
            <Button
                variant="contained"
                onClick={props.callBackX}
                sx={{ mt: 1, mr: 1 }}
            >
                Назад
            </Button>

        </div>
    </Box>
        </>
    );
};

export default Contacts;